import * as React from 'react';

import ParamsBuilder from './params_builder';
import { InjectedRouter, withRouter } from 'react-router';
import { get } from 'lodash';
import bind from '@reverbdotcom/commons/dist/bind';
import { Location } from 'history';

interface IProps {
  placeholder: string;
  location: Location;
  router?: InjectedRouter;
}

interface IState {
  query: string;
}

class SaleSearchBar extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = { query: '' };
  }

  submitQuery() {
    const newParams = ParamsBuilder.set(this.props.location.query, { query: this.state.query });

    this.props.router.push({
      pathname: this.props.location.pathname,
      query: newParams,
    });
  }

  @bind
  handleSubmit(evt) {
    evt.preventDefault();

    this.submitQuery();
  }

  @bind
  handleChange(evt) {
    evt.preventDefault();
    this.setState({ query: evt.target.value });
  }

  render() {
    return (
      <form className="sale-information__search" onSubmit={this.handleSubmit}>
        <div className="input-group">
          <input
            id="collection_header_search"
            type="text"
            placeholder={this.props.placeholder}
            className="input-group__input"
            defaultValue={get(this.props.location, 'query.query') || ''}
            onChange={this.handleChange}
          />
          <button type="submit" className="input-group__button size-80">
            <span className="fa fa-chevron-right" />
          </button>
        </div>
      </form>
    );
  }
}

export default withRouter(SaleSearchBar);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/sale_search_bar.tsx